import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Box, styled } from '@mui/material';

export const AppBarOuterWrapperStyled = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isFormPage' &&
    prop !== 'isOnboardingAdvancedSteps' &&
    prop !== 'isMobile',
})(({ theme, isFormPage, isOnboardingAdvancedSteps, isMobile }) => ({
  width: '100%',
  backgroundColor: theme.palette.colors.actionBar,
  position: 'fixed',
  zIndex: isMobile ? theme.zIndex.modal + 1 : 1,
  borderBottom: `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,

  [theme.breakpoints.up('lg')]: {
    width: isFormPage && '50%',
    backgroundColor: isFormPage
      ? theme.palette.colors.primaryBackground
      : theme.palette.colors.homePageBackground,
    right: isFormPage && 0,
    borderBottom: 'none',
  },
  [theme.breakpoints.up('xxl')]: {
    width: isOnboardingAdvancedSteps && 'calc(100vw - 532px)',
    right: isOnboardingAdvancedSteps && 0,
  },
  [theme.breakpoints.up('xxxxl')]: {
    width: isOnboardingAdvancedSteps && 'calc(100vw - 640px)',
    right: isOnboardingAdvancedSteps && 0,
  },
}));

export const AppBarWrapperStyled = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== 'isAuthenticated' &&
    prop !== 'isFormPage' &&
    prop !== 'isOnboardingAdvancedSteps',
})(({ theme, isAuthenticated, isFormPage, isOnboardingAdvancedSteps }) => {
  const getVariableProperties = () => {
    if (isAuthenticated)
      return {
        background: theme.palette.colors.primaryBackground,
        paddingTop: '30px',
        paddingBottom: '6px',

        [theme.breakpoints.up('xxxl')]: {
          paddingTop: '40px',
          paddingBottom: '16px',
        },
        [theme.breakpoints.up('lg')]: {
          borderBottom: `solid 1px ${theme.palette.colors.scrollOnPrimaryBackground}`,
        },
        [theme.breakpoints.down('lg')]: {
          justifyContent: 'center',
          backgroundColor: theme.palette.colors.primaryBackground,
          position: 'fixed',
          bottom: 71,
          top: 'auto',
          height: '56px',
          paddingTop: 0,
          paddingBottom: 0,
          borderTop: `solid 1px ${theme.palette.colors.scrollOnPrimaryBackground}`,
        },
      };

    return {
      height: '64px',
      width: '328px',
      backgroundColor: 'transparent',
      marginInline: 'auto',
      paddingTop: 0,
      paddingBottom: 0,

      [theme.breakpoints.up('sm')]: {
        width: '468px',
      },
      [theme.breakpoints.up('md')]: {
        width: '620px',
      },
      [theme.breakpoints.up('lg')]: {
        height: 'auto',
        width: isFormPage ? '340px' : '944px',
        paddingTop: '49px',
        paddingBottom: '24px',
      },
      [theme.breakpoints.up('xxl')]: {
        width: isOnboardingAdvancedSteps
          ? 'calc(100vw - 532px - 96px - 96px)'
          : isFormPage
            ? '340px'
            : '1304px',
      },
      [theme.breakpoints.up('xxxxl')]: {
        width: isOnboardingAdvancedSteps
          ? 'calc(100vw - 640px - 112px - 112px)'
          : isFormPage
            ? '340px'
            : '1456px',
      },
    };
  };
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingInline: '0 !important',
    position: 'relative',
    boxShadow: 'none',

    ...getVariableProperties(),
  };
});

export const AppBarLeftStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isAuthenticated',
})(({ theme, isAuthenticated }) => ({
  display: 'flex',
  alignItems: 'center',
  zIndex: 1,

  '& > *:not(:last-child):not(:first-of-type)': {
    marginRight: '25px',
  },

  [theme.breakpoints.up('lg')]: {
    paddingLeft: isAuthenticated && '24px',
  },
  [theme.breakpoints.up('xl')]: {
    paddingLeft: isAuthenticated && '32px',
  },
}));

export const AppBarRightStyled = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isAuthenticated' && prop !== 'hide' && prop !== 'isMobile',
})(({ theme, isAuthenticated, hide, isMobile }) => ({
  display: hide ? 'none' : 'flex',
  alignItems: 'center',
  gap: !isAuthenticated && '16px',
  zIndex: isMobile ? theme.zIndex.modal + 1 : 1,

  [theme.breakpoints.up('lg')]: {
    paddingRight: isAuthenticated && '32px',
  },
}));

export const GoBackArrow = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  display: 'none',

  [theme.breakpoints.up('lg')]: {
    display: isFormPage && 'block',
    height: '24px',
    color: theme.palette.colors.onPrimaryBackground,
    position: 'absolute',
    marginLeft: '24px',
    marginTop: 'calc(49px + 23px - 12px)',
    cursor: 'pointer',
  },
  [theme.breakpoints.up('xxxxl')]: {
    marginLeft: '40px',
  },
}));

export const OnboardingButtonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSubMenuOpen',
})(({ theme, isSubMenuOpen }) => ({
  ...(isSubMenuOpen && {
    '& > .MuiButtonBase-root': {
      border: `1px solid ${theme.palette.colors.mainFocused}`,
    },
  }),
}));
